import constants from '../constants'

constants.install = function (Vue) {
  Vue.prototype.$getConst = (key) => {
    return constants[key]
  }
}

export default constants
